import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import * as api from '../../../api'
import UserBar from '../../common/user-bar/user-bar'
import { Helmet } from 'react-helmet'

const scope = 'CommandsPage'

const minLevelText = minLevel => {
  if (!minLevel || minLevel < 1) {
    return null
  }
  switch (minLevel) {
    case 1:
      return <div className={classnames(`${scope}-Sub`)}>Subscribers</div>
    case 2:
      return <div className={classnames(`${scope}-VIP`)}>VIPs</div>
    case 3:
      return <div className={classnames(`${scope}-Mod`)}>Moderators</div>
    case 4:
      return <div className={classnames(`${scope}-BO`)}>Broadcaster</div>
    default:
      return null
  }
}

class CommandList extends Component {
  render() {
    const { title, keyID, commands } = this.props
    if (!commands || !commands.length) {
      return null
    }
    return (
      <div className={classnames(`${scope}-CommandList`)}>
        <div className={classnames(`${scope}-CommandType`)}>{title}</div>
        {commands.map(({ command, description, minLevel }, i) => (
          <div key={`${keyID}_${i}`} className={classnames(`${scope}-Command`, !description && `${scope}-Command-NoDescription`)}>
            <div className={classnames(`${scope}-Text`)}><em>!</em>{command}</div>
            <div className={classnames(`${scope}-Description`)}>{description}</div>
            <div className={classnames(`${scope}-Level`)}>{minLevelText(minLevel)}</div>
          </div>
        ))}
      </div>
    )
  }
}

class Commands extends Component {
  render() {
    const {
      commands,
      custom,
      sound,
      counter
    } = this.props
    return (
      <Fragment>
        <CommandList title="Built-In Commands" commands={commands} description />
        <CommandList title="Custom Commands" commands={custom} />
        <CommandList title="Sound Commands" commands={sound} />
        <CommandList title="Counter Commands" commands={counter} />
      </Fragment>
    )
  }
}

class UserInfo extends Component {
  render() {
    const {
      name,
      online,
      avatar,
      commands,
    } = this.props

    return (
      <Fragment>
        <div className={classnames(`${scope}-UserInfo`)}>
          <img alt='' className={classnames(`${scope}-Avatar`)} src={avatar} />
          <div className={classnames(`${scope}-Name`)}>{name}</div>
          <div className={classnames(`${scope}-Live`)}>{online ? <div>Live</div> : <div className={classnames(`${scope}-Offline`)}>Offline</div>}</div>
        </div>
        {commands ? <Commands {...commands} /> : null}
        {commands && commands.version ? <div className={classnames(`${scope}-Version`)}>Using {commands.version}</div> : null}
      </Fragment>
    )
  }
}

class CommandsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingUser: true,
      userInfo: {},
    }
    this.logOut = this.logOut.bind(this)
  }

  componentDidMount() {
    this.getUserData()
    this.getCommands()
  }

  getUserData() {
    api
      .getUserData()
      .then(user => {
        this.setState({
          loading: false,
          user,
        })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  logOut() {
    api.logOut().then(this.setState({ user: null }))
  }

  getCommands() {
    api.getCommands(this.props.match.params.name).then(({ commands, ...rest }) => {
      let parsedCommands = {}
      try {
        parsedCommands = JSON.parse(commands)
      } catch (e) {

      }
      this.setState({ loadingUser: false, userInfo: { ...rest, commands: parsedCommands } })
    }).catch(() => {
      this.setState({ loadingUser: false, commandError: true })
    })
  }

  createTitle = pageTitle => {
    const { config } = this.props
    const title = 'Commands'

    if (config.siteName && title && pageTitle) {
      return `${title}: ${pageTitle} - ${config.siteName}`
    } else if (config.siteName && title) {
      return `${title} - ${config.siteName}`
    } else if (config.siteName) {
      return config.siteName
    }
  }

  renderTitle = () => {
    const { loading, error, userInfo } = this.state

    if (loading) {
      return null
    }
    if (error || !userInfo || !userInfo.name) {
      return null
    }
    return (
      <Helmet>
        <title>{this.createTitle(userInfo.name)}</title>
      </Helmet>
    )
  }

  render() {
    const { className } = this.props
    const { loading, user, loadingUser, userInfo, commandError } = this.state

    return (
      <div className={classnames(scope, className)}>
        {this.renderTitle()}
        <div className={classnames(`${scope}-Header`)}>
          {!loading ? <UserBar user={user} onLogOut={this.logOut} /> : null}
        </div>
        {!loadingUser && !commandError ? <UserInfo {...userInfo} /> : null}
        {!loadingUser && commandError ? <div className={classnames(`${scope}-DoesntUse`)}><div>☹</div>Looks like this streamer doesn't use our chatbot!</div> : null}
      </div>
    )
  }
}

export default CommandsPage



// WEBPACK FOOTER //
// ./src/components/views/commands-page/commands-page.jsx